import { Observable } from 'rxjs';

import { OfferEventDto } from '@core/mappers/offer/dtos/OfferEventDto';
import OfferEvent from '@core/models/offer/OfferEvent';
import Category from '@core/models/struct/Category';
import Market from '@core/models/struct/Market';
import MarketGroupInfo from '@core/models/struct/MarketGroupInfo';
import OddType from '@core/models/struct/OddType';
import Sport from '@core/models/struct/Sport';
import Struct from '@core/models/struct/Struct';
import Tournament from '@core/models/struct/Tournament';

import { MatchDetailsSseConnection } from './connections/MatchDetailsSseConnection';
import { CategoryDto } from '@core/mappers/struct/dtos/CategoryDto';
import { TournamentDto } from '@core/mappers/struct/dtos/TournamentDto';
import { OutcomeDto } from '@core/mappers/struct/dtos/OutcomeDto';
import { SportDto } from '@core/mappers/struct/dtos/SportDto';

export type MatchEvent = {
    resourceId: string;
    timestamp: number | null;
    data: OfferEventDto;
};

export const SseStructType = {
    Sport: 'sport',
    Category: 'category',
    Tournament: 'tournament',
    Outcome: 'outcome',
    OddType: 'oddType',
    MarketGroup: 'marketGroup',
    BetGroup: 'betGroup',
} as const;
export type SseStructType = typeof SseStructType[keyof typeof SseStructType];

export type StructEvent = {
    resourceId: string;
    type: SseStructType;
    data: StructEventDto;
    timestamp: number;
    id: number;
};

export type StructEventDto =
    | CategoryDto
    | TournamentDto
    | OutcomeDto
    | SportDto;

export type LiveEventCountEvent = {
    count: number;
};

export type InitialEvent = {
    resourceId: string;
    timestamp: number | null;
};

export type OfferUpdateEvent = SyncronizableEvent | LiveEventCountEvent;

export type SyncronizableEvent = DataEvent | InitialEvent;

export type DataEvent = MatchEvent | StructEvent;

// SuperOffer and MarketTree are not included in the SSE streams
export type SseStructure = Omit<Struct, 'superOffer' | 'marketTree'>;

export type BasicEvent =
    | Sport
    | Tournament
    | Category;

export type MappedStructEvent =
    | BasicEvent
    | MarketGroupInfo
    | OddType
    | Market;

export const OutOfSyncUpdate = 'OutOfSyncUpdate';

export type OutOfSyncUpdateType = typeof OutOfSyncUpdate;

export type SseUpdate<Data> = Data | OutOfSyncUpdateType;

export type EventStream = {
    connection: MatchDetailsSseConnection;
    observable?: Observable<SseUpdate<OfferEvent>>;
    subscriptionCount: number;
};

export type TimestampsMap = Record<string, number>;
